import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=2b620801&"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js&"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports